import {FaSearch} from 'react-icons/fa';
import styled from 'styled-components';

export const SearchIcon = styled(FaSearch)`
  font-size: 20px;
  cursor: pointer;
`;
